import { useTranslator } from "@eo-locale/react";

import { ChangeEvent } from "react";

import { string } from "yup";

import { CommonSingleLineQuestion } from "@/storybook-components";
import type { PlacesQuestion, Question } from "@/types";
import { setAnswer } from "@/redux/features/place-form/slice";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";

export const validate = async (
  answer: string,
  question: Question
): Promise<string[]> => {
  let schema = string();
  if (question.required) {
    schema = schema.required();
  }
  try {
    await schema.max(question.maxLength || 255).validate(answer);
    return [];
  } catch (err) {
    return err.errors;
  }
};

const SingleLineQuestionComponent = (props: PlacesQuestion) => {
  const { question } = props;
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const { answers, answerErrors } = useAppSelector((state) => state.placesForm);

  const error = answerErrors[question?.id] || "";
  const SingleLineAnswer = answers[question?.id] || "";

  const { question: title, id, required, notes, maxLength } = question || {};

  const handleChange = (e: ChangeEvent<any>): void => {
    dispatch(
      setAnswer({
        questionId: question.id,
        answer: e.target.value
      })
    );
  };

  return (
    <div className={"places-common-single-line"}>
      <CommonSingleLineQuestion
        answer={SingleLineAnswer}
        isInvalid={error.length}
        isRequired={required}
        withErrorIcon={error.length}
        questionLabelProps={{
          marginTop: 6
        }}
        noteProps={{
          color: "gray.800"
        }}
        changeEventHandler={handleChange}
        spacing={0}
        questionId={id}
        errorMessage={error && translate(`errors.${error}`)}
        note={notes}
        questionLabel={title}
        className={`${error.length ? "ehqQuestionError" : null}`}
        maxLength={maxLength || 255}
        maxNote={translate(`places.maximumCharachtersText`, {
          count: maxLength || 255
        })}
      />
    </div>
  );
};

export default SingleLineQuestionComponent;
